import React, { useState } from "react";
import {
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Tooltip,
  Modal,
  Box,
} from "@material-ui/core";
import { Inbox as InboxIcon } from "@material-ui/icons";
import { Link, useLocation } from "react-router-dom";
import classnames from "classnames";
import { useHistory } from "react-router-dom";
import { useUserDispatch, signOut } from "../../../../context/UserContext";

// styles
import useStyles from "./styles";

// components
import Dot from "../Dot";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "none",
  outline: "none",
  boxShadow: 24,
  borderRadius: "10px",
  p: 4,
};
export default function SidebarLink({
  link,
  icon,
  label,
  children,
  location,
  isSidebarOpened,
  nested,
  type,
  props,
}) {
  let history = useHistory();
  var userDispatch = useUserDispatch();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [path, setPath] = useState(null);
  // const handleOpen=()=>{
  //   alert("sfsdfsdf")
  // }
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const isLinkActive =
    link &&
    (location.pathname === link ||
      (children && location.pathname.startsWith(link + "/")));
  const logout = (e) => {
    window.location.href = "/login"; // Redirect
    history.push("/login");
    localStorage.clear(); // Clear all stored data
  };
  if (type === "title")
    return (
      <Typography
        className={classnames(classes.linkText, classes.sectionTitle, {
          [classes.linkTextHidden]: !isSidebarOpened,
        })}
      >
        {label}
      </Typography>
    );

  if (type === "divider") return <Divider className={classes.divider} />;

  const handlePath = (link) => {
    console.log(link, "link");
    //  window.location.href=link
    history.push(link);
  };

  // No children - simple link
  if (!children)
    return (
      <>
        <Tooltip title={!isSidebarOpened ? label : ""} placement="right" arrow>
          <ListItem
            button
            component={link && Link}
            // to={link}
            onClick={label === "Logout" ? handleOpen : () => handlePath(link)}
            className={classes.link}
            classes={{
              root: classnames(classes.linkRoot, {
                [classes.linkActive]: isLinkActive && !nested,
                [classes.linkNested]: nested,
              }),
            }}
            disableRipple
          >
            <ListItemIcon
              className={classnames(classes.linkIcon, {
                [classes.linkIconActive]: isLinkActive,
              })}
            >
              {nested ? <Dot color={isLinkActive && "primary"} /> : icon}
            </ListItemIcon>
            <ListItemText
              classes={{
                primary: classnames(classes.linkText, {
                  [classes.linkTextActive]: isLinkActive,
                  [classes.linkTextHidden]: !isSidebarOpened,
                }),
              }}
              primary={label}
            />
          </ListItem>
        </Tooltip>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <span className="logout_notify_icon">
              {/* <i class="fa-solid fa-circle-exclamation"></i> */}
              <img src={require("../../../../images/logout.png")} />
            </span>
            <h5 className="logout_title" style={{textAlign:'center'}}>Logout Notification</h5>
            <p className="logout_content" style={{textAlign:'center'}}>Are your sure Logout to the Site?</p>
            <div className="logout_btn_wrapper" style={{justifyContent:'center'}}>
              <button
                className="logout_cancel custom_btn2 text-center"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="logout_confirm custom_btn2 text-center"
                onClick={() => logout()}
                // onClick={() => (signOut(userDispatch, props.history),handleClose())}
              >
                Logout
              </button>
            </div>
          </Box>
        </Modal>
      </>
    );

  // With children - collapsible group
  return (
    <>
      <Tooltip title={!isSidebarOpened ? label : ""} placement="right" arrow>
        <ListItem
          button
          onClick={toggleCollapse}
          className={classes.link}
          disableRipple
        >
          <ListItemIcon
            className={classnames(classes.linkIcon, {
              [classes.linkIconActive]: isLinkActive,
            })}
          >
            {icon ? icon : <InboxIcon />}
          </ListItemIcon>
          <ListItemText
            classes={{
              primary: classnames(classes.linkText, {
                [classes.linkTextActive]: isLinkActive,
                [classes.linkTextHidden]: !isSidebarOpened,
              }),
            }}
            primary={label}
          />
        </ListItem>
      </Tooltip>

      <Collapse
        in={isOpen && isSidebarOpened}
        timeout="auto"
        unmountOnExit
        className={classes.nestedList}
      >
        <List component="div" disablePadding>
          {children.map((childLink) => {
            console.log("======================================");
            return (
              <SidebarLink
                key={childLink && childLink.link}
                location={location}
                isSidebarOpened={isSidebarOpened}
                nested
                {...childLink}
              />
            );
          })}
        </List>
      </Collapse>
    </>
  );

  // Helper
  function toggleCollapse(e) {
    console.log(e, "--");
    if (isSidebarOpened) {
      e.preventDefault();
      setIsOpen(!isOpen);
    }
  }
}
